(() => {
  if (window.__RavinPulseLoaded) return;
  window.__RavinPulseLoaded = true;

  const instances = new WeakMap();

  function init(root) {
    if (!root || instances.has(root)) return;

    const toggle = root.querySelector('[data-rp-toggle]');
    const menu = root.querySelector('[data-rp-menu]');
    const chatAction = root.querySelector('[data-rp-chat]');
    const vipAction = root.querySelector('[data-rp-vip]');
    const dismiss = root.querySelector('[data-rp-dismiss]');
    const isArabic = root.dataset.rpAr === 'true';
    if (!toggle || !menu || !chatAction || !vipAction) return;

    const controller = new AbortController();
    const designMode = root.dataset.rpEditor === 'true' || Boolean(window.Shopify && window.Shopify.designMode);
    let nativeChat = null;
    let nativeVip = null;
    let observedPanel = null;
    let panelObserver = null;
    let isExpanded = false;

    function expand(next) {
      isExpanded = Boolean(next);
      root.dataset.rpExpanded = String(isExpanded);
      toggle.setAttribute('aria-expanded', String(isExpanded));
      toggle.setAttribute('aria-label', isArabic ? (isExpanded ? 'اقفل اختيارات ريفين' : 'افتح اختيارات ريفين') : (isExpanded ? 'Close RAVIN Pulse options' : 'Open RAVIN Pulse options'));
      const badge = root.querySelector('.ravin-pulse__mini-badge');
      if (badge) badge.textContent = isExpanded ? '−' : '+';
      menu.inert = !isExpanded;
      menu.setAttribute('aria-hidden', String(!isExpanded));
    }

    // The global floating-widget coordinator can minimize Pulse without
    // focusing its launcher or interfering with the tapped destination.
    root.addEventListener('ravin:float:close', () => {
      if (isExpanded) expand(false);
    }, { signal: controller.signal });

    function watchChatPanel() {
      const panel = document.querySelector('body > .ravin-widget-container');
      if (panel !== observedPanel) {
        if (panelObserver) panelObserver.disconnect();
        observedPanel = panel;
        if (panel) {
          panelObserver = new MutationObserver(updateChatPanel);
          panelObserver.observe(panel, { attributes: true, attributeFilter: ['class'] });
        }
      }
      updateChatPanel();
    }

    function updateChatPanel() {
      const chatOpen = Boolean(observedPanel && observedPanel.classList.contains('active'));
      root.classList.toggle('is-chat-open', chatOpen);
      if (chatOpen && isExpanded) expand(false);
    }

    function syncWidgets() {
      nativeChat = document.querySelector('body > button.ravin-launcher-btn');
      nativeVip = document.querySelector('body > a.ravin-vip-btn');
      // Sidekick V2 provides a chat launcher without a separate VIP button.
      // The chat action is sufficient to keep Pulse inside Paper Gang ready;
      // the existing VIP fallback URL remains usable when nativeVip is absent.
      const integrated = Boolean(nativeChat);

      if (nativeVip) {
        const href = nativeVip.getAttribute('href');
        if (href && !/^\s*javascript:/i.test(href)) vipAction.setAttribute('href', href);
        const target = nativeVip.getAttribute('target');
        if (target === '_blank') {
          vipAction.target = '_blank';
          vipAction.rel = 'noopener noreferrer';
        } else {
          vipAction.target = '_self';
          vipAction.removeAttribute('rel');
        }
      }

      root.classList.toggle('is-ready', integrated || designMode);
      document.documentElement.classList.toggle('ravin-pulse-integrated', integrated);
      chatAction.disabled = !nativeChat;
      if (!integrated && !designMode && isExpanded) expand(false);
      watchChatPanel();
      updatePulseDock();
    }

    function updateKeyboard() {
      const viewport = window.visualViewport;
      const focused = document.activeElement;
      const typing = Boolean(focused && (focused.matches('input, textarea, [contenteditable="true"]')));
      const keyboardHeight = viewport ? window.innerHeight - viewport.height - viewport.offsetTop : 0;
      const open = typing && keyboardHeight > 145;
      root.classList.toggle('is-keyboard', open);
      if (open && isExpanded) expand(false);
    }

    // On mobile product pages, keep Pulse fully above the fixed purchase controls.
    // Measure the actual sticky bar instead of assuming a constant device height.
    let stickyObserver = null;
    let observedStickyCart = null;
    function updatePulseDock() {
      const stickyCart = document.querySelector('[data-ravin-pdp-editorial] [data-sticky-cart]');
      if (stickyCart !== observedStickyCart) {
        if (stickyObserver) stickyObserver.disconnect();
        observedStickyCart = stickyCart;
        stickyObserver = stickyCart && 'ResizeObserver' in window
          ? new ResizeObserver(updatePulseDock) : null;
        if (stickyObserver) stickyObserver.observe(stickyCart);
      }
      if (window.matchMedia('(max-width: 989px)').matches && stickyCart && stickyCart.getClientRects().length) {
        root.style.bottom = String(Math.ceil(stickyCart.getBoundingClientRect().height) + 14) + 'px';
      } else {
        root.style.removeProperty('bottom');
      }
    }

    toggle.addEventListener('click', () => expand(!isExpanded), { signal: controller.signal });
    if (dismiss) dismiss.addEventListener('click', () => { expand(false); toggle.focus({ preventScroll:true }); }, {signal:controller.signal});

    chatAction.addEventListener('click', () => {
      const launcher = document.querySelector('body > button.ravin-launcher-btn');
      if (!launcher) return;
      expand(false);
      launcher.click();
      watchChatPanel();
    }, { signal: controller.signal });

    vipAction.addEventListener('click', () => expand(false), { signal: controller.signal });

    document.addEventListener('pointerdown', event => {
      if (isExpanded && !root.contains(event.target)) expand(false);
    }, { signal: controller.signal });

    document.addEventListener('keydown', event => {
      if (event.key === 'Escape' && isExpanded) {
        expand(false);
        toggle.focus({ preventScroll: true });
      }
    }, { signal: controller.signal });

    document.addEventListener('focusin', updateKeyboard, { signal: controller.signal });
    document.addEventListener('focusout', updateKeyboard, { signal: controller.signal });
    window.addEventListener('pageshow', syncWidgets, { signal: controller.signal });
    window.addEventListener('resize', updatePulseDock, { signal: controller.signal });

    if (window.visualViewport) {
      window.visualViewport.addEventListener('resize', updateKeyboard, { signal: controller.signal });
      window.visualViewport.addEventListener('scroll', updateKeyboard, { signal: controller.signal });
    }

    const widgetObserver = new MutationObserver(syncWidgets);
    widgetObserver.observe(document.body, { childList: true });

    const cleanup = () => {
      widgetObserver.disconnect();
      if (panelObserver) panelObserver.disconnect();
      if (stickyObserver) stickyObserver.disconnect();
      root.style.removeProperty('bottom');
      controller.abort();
      document.documentElement.classList.remove('ravin-pulse-integrated');
      root.classList.remove('is-ready');
      instances.delete(root);
    };

    instances.set(root, cleanup);
    expand(false);
    syncWidgets();
    updateKeyboard();
  }

  function initIn(scope) {
    if (scope.matches && scope.matches('[data-ravin-pulse]')) init(scope);
    if (scope.querySelectorAll) scope.querySelectorAll('[data-ravin-pulse]').forEach(init);
  }

  function unloadIn(scope) {
    const roots = [];
    if (scope.matches && scope.matches('[data-ravin-pulse]')) roots.push(scope);
    if (scope.querySelectorAll) roots.push(...scope.querySelectorAll('[data-ravin-pulse]'));
    roots.forEach(root => {
      const cleanup = instances.get(root);
      if (cleanup) cleanup();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initIn(document), { once: true });
  } else {
    initIn(document);
  }
  document.addEventListener('shopify:section:load', event => initIn(event.target));
  document.addEventListener('shopify:section:unload', event => unloadIn(event.target));
})();